{
  "common": {
    "back": "Zpět",
    "user": "Uživatel"
  },
  "login": {
    "login-label": "Přihlásit se",
    "apple-login-label": "Přihlásit se s Apple ID",
    "heading": "Pro přístup se prosím přihlašte",
    "disclaimer": "Přihlašte se nebo kontaktujte Klientskou linku.",
    "footerValue": "800 707 606",
    "footerLabel": "Klientská linka:",
    "error": {
      "creds-not-found": "Pro přihlášení potřebujete passkey, který vytvoříte při registraci přes mobilní aplikaci J&T Assets",
      "generic": "Přihlášení selhalo",
      "unauthorized": "Vaše relace vypršela. Přihlaste se prosím znovu."
    },
    "apple-id" : {
      "finish": "Přihlášení se dokončuje."
    }
  },
  "upload": {
    "banner": {
      "heading": "Import dat do aplikace",
      "subheading": "Jednorázové naplnění seznamu majetku bez nutnosti manuálního vkládání."
    },
    "downloadTemplate": {
      "heading": "Šablona k vyplnění",
      "subheading": "Stáhněte si naši šablonu, abyste měli jistotu, že data budou ve správném formátu.",
      "category": "Kategorie majetku",
      "categoryPlaceholder": "Vyberte kategorii majetku",
      "categoryInfoHeading": "Šablona obsahuje tato data:",
      "downloadButton": "Stáhnout šablonu",
      "genericMessage": "-",
      "alcohol": {
        "type": "Typ nápoje (Jakákoli hodnota)",
        "volume": "Objem",
        "volume_unit_measure": "Jednotka (L - Litry, ML - Mililitry, FL_OZ - tekutá unce)",
        "name": "Název",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Pořizovací cena",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)"
      },
      "realEstate": {
        "property_type": "Typ nemovitosti (FAMILY_HOUSE - Rodinný dům,  APARTMENT - Byt, LAND - Pozemek, OTHER - Ostatní,",
        "land_type": "Typ pozemku (BUILDING - Budova, FIELD - Pole, GARDEN - Zahrada, MEADOW - Louka,  FOREST - Les, OTHER - Ostatní)",
        "zip_code": "PSČ",
        "municipality_name": "Obec",
        "street_name": "Ulice",
        "house_number": "Číslo domu",
        "area": "Výměra (v m²)",
        "rating": "Stav nemovitosti (BAD -  Neobyvatelný, NOTHING_MUCH - Před rekonstrukcí, GOOD - Průměrný, VERY_GOOD - Po kompletní rekonstrukci, NEW - Novostavba, EXCELLENT - Luxusní)",
        "name": "Pojmenujte nemovitost",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Pořizovací cena",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)"
      },
      "gemstone": {
        "type": "Druh (Jakákoli hodnota)",
        "name": "Název",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Pořizovací cena",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)"
      },
      "coin": {
        "name": "Název",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Pořizovací cena",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)"
      },
      "art": {
        "author": "Autor",
        "name": "Název",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Pořizovací cena",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)"
      },
      "loan": {
        "interest": "Úroková sazba",
        "name": "Název",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Výše půjčky",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)",
        "state": "Stav (ACTIVE - Aktivní, INACTIVE - Neaktivní, ON_HOLD - Pozastaveno)"
      },
      "banknote": {
        "name": "Název",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Pořizovací cena",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)"
      },
      "car": {
        "manufacturer":  "Značka",
        "model": "Model",
        "name": "Název",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Pořizovací cena",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)"
      },
      "jewels": {
        "manufacturer":  "Výrobce",
        "model": "Model",
        "name": "Název",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Pořizovací cena",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)"
      },
      "instrument": {
        "type":  "Druh nástroje (Jakákoli hodnota)",
        "manufacturer": "Výrobce a model",
        "name": "Název",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Pořizovací cena",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)"
      },
      "share": {
        "share":  "Velikost podílu",
        "name": "Název společnosti",
        "purchase_date": "Datum pořízení ve formatu ISO 8601 (RRRR-MM-DD)",
        "purchase_price": "Vstupní investice",
        "purchase_currency": "Nákupní měna (CZK, USD, EUR)"
      }
    },
    "importFile": {
      "heading": "Import dat",
      "subheading": "Nahrajte prosím vyplněnou šablonu, aby bylo možné vaše data dále zpracovat.",
      "category": "Kategorie majetku",
      "categoryPlaceholder": "Vyberte kategorii majetku",
      "finishImport": "Dokončit import",
      "success": "Soubor byl úspěšně nahrán a zpracovává se.",
      "fail": "Soubor se nepodařilo nahrát, zkontrolujte typ souboru nebo formát dat."
    },
    "faq": {
      "heading": "Nápověda a časté dotazy",
      "questions": {
        "supportedFormat": {
          "question": "Jaký formát souborů je podporován?",
          "answer": "V současné verzi systému je podporován formát CSV."
        },
        "mandatoryCols": {
          "question": "Jaké sloupce jsou povinné?",
          "answer": "Pro přehled a základní identifikaci majetku je nutné zadat alespoň jeho jméno."
        },
        "dataFormat": {
          "question": "Jak mám formátovat data?",
          "answer": "CSV je textový dokument, který má specifické formátování. Veškeré hodnoty musí být vloženy do dvojitých uvozovek.",
          "additionalList": {
            "0": "Text: \"text\"",
            "1": "Dlouhý text: \"Dlouhý text s čárkou, uprostřed\"",
            "2":  "Číslo: \"123,4\""
          }
        },
        "update": {
          "question": "Mohu aktualizovat existující majetek?",
          "answer": "Ne, import slouží pouze pro prvotní naplnění systému daty. Úpravy hodnot je nutné provést přes editaci daného majetku přímo v aplikaci. Systém kontroluje existenci majetku pomocí složeného klíče \"kategorie\" a \"jména majetku\". Pokud tedy v dané kategorii již existuje majetek s daným názvem, tento se vícekrát nezaloží a ani se neupravují jeho hodnoty."
        },
        "failed": {
          "question": "Co se stane, když import selže?",
          "answer": "Import dat může v závislosti na množství dat trvat různou dobu. Čím více dat, tím déle může import trvat. Při importu systém provádí kontrolu importovaného majetku a jednotlivých hodnot. Z tohoto důvodu uživatel nedostane okamžitou zpětnou vazbu ohledně chyb nebo kvality dat. Zpětná vazba importu je prováděna pomocí e-mailové notifikace, která je odeslána na elektronickou adresu vlastníka účtu po ukončení importu."
        }
      }
    }
  },
  "fileUploader": {
    "cal": "Vyberte soubor",
    "desc": "nebo ho sem přetáhněte",
    "supported": "(podporovaný formát: CSV)",
    "error": {
      "file-ext": "Soubor nelze nahrát, zkontrolujte typ souboru."
    }
  },
  "categories": {
    "PROPERTY": "Nemovitost",
    "JEWELS": "Hodinky a Šperky",
    "CAR": "Automobily",
    "GEMSTONE": "Drahé kameny",
    "ALCOHOL": "Alkohol",
    "INSTRUMENT": "Hudební nástroje",
    "COIN": "Mince",
    "BANKNOTE": "Bankovky",
    "ART": "Umění",
    "LOAN": "Půjčky",
    "SHARES": "Majetkové podíly",
    "OTHER": "Jiné"
  }
}
